import { apiAddress } from "constants/apiAddress";
import { LocalStorageKeys } from 'constants/localStorageKeys';


export const getAllDevices = async () =>
    await fetch(`${apiAddress}/admins/devices-list`, {
        method: "GET",
        headers:{
            "Authorization":`Bearer ${localStorage.getItem(LocalStorageKeys.JWT_TOKEN)}`
            }})
        .then((response) => response.json())
        .catch((reason) => console.error(reason));


export const getSpecificDevice = async (device_id: string) =>
    await fetch(`${apiAddress}/admins/devices-list/${device_id}`, {
        method: "GET",
        headers:{
            "Authorization":`Bearer ${localStorage.getItem(LocalStorageKeys.JWT_TOKEN)}`
            }})
        .then((response) => response.json());

        
export const addNewDevice = async (device_family_id: number, description: string) =>
    await fetch(`${apiAddress}/admins/devices-list`, {
        method: 'POST',
        headers:{
        "Authorization":`Bearer ${localStorage.getItem(LocalStorageKeys.JWT_TOKEN)}`,
        "Content-Type": "application/json"
        },
        body: JSON.stringify({
            "device_family_id": device_family_id,
            "description": description
        })
    })
    .then((response) => response.ok ? response.ok : false)
    .catch((reason) => console.error(reason));


export const deleteDevice = async (device_id: string) =>
    await fetch(`${apiAddress}/admins/devices-list/${device_id}`, {
        method: 'DELETE',
        headers:{
        "Authorization":`Bearer ${localStorage.getItem(LocalStorageKeys.JWT_TOKEN)}`
        }
    })
    .then((response) => response.ok ? response.ok : false)
    .catch((reason) => console.error(reason));